import { Formik, Field, Form } from 'formik';
import React, { useEffect } from 'react'
import { Button, Modal, Form as FormUi, Grid } from 'semantic-ui-react'
import billingPartyDropdown from '../dropdowns/billingPartyDropdown';
import CustomerBranchDropdown from '../dropdowns/customerBranchDropdown';
// import BillingPartyDropdown from '../dropdowns/billingPartyDropdown';
// import BillingPartyDropdown from './billingPartyDropdown';
// import CustomerBranchDropdown from './customerBranchDropdown';
import { buttons, fields, titles } from './creditNote.constants';

function CreditNoteFilterModal(props) {

  const [customerName, setCustomerName] = React.useState("");
  const [branchData, setBranchData] = React.useState([]);
  const [selectedBranchCode, setSelectedBranchCode] = React.useState('');

  const handleReset = () => {
    props.setData({ ...props.data, clientCode: '', branchCode: '' })
    props.handleClose()
    window.location.reload()
  }

  const getBranchData = childData => {
    props.setData({ ...props.data, branchCode: '' })
    setBranchData(childData || [])
    props.setBranchOptions(childData)
  };

  const getBranchSelected = childData => {
    setSelectedBranchCode(childData)
    props.setSelectedBranch(childData)
    const branchDetails = branchData.find(data => data.billingPartyBranchCode === childData);
  }

  return (
    <Modal
      centered={false}
      open={props.open}
    >
      <Modal.Header>{titles.flterBy}</Modal.Header>
      <Modal.Content>
        <div className="ui form small">
          <Formik
            initialValues={props.data}
            onSubmit={(values) => {
              props.setData(values)
              props.handleSearch(values)
              props.handleClose()
            }
            }
          >
            <Form id='filter-form'>
              <FormUi.Group inline={true} verticalAlign='middle'>
                <FormUi.Field width='8' style={{ maxHeight: '40%' }}>

                  <label htmlFor="clientCode">{fields.customer.title}</label>
                  <Field
                    component={billingPartyDropdown}
                    name="clientCode"
                    placeholder={fields.customer.placeholder}
                    value={props.selectUser || ''}
                    setLastOptions={props.setDefaultOptions}
                    defaultOptions={props.defaultOptions}
                    setCustomerName={(data) => {
                      setCustomerName(data)
                      props.selectCustomerName(data)
                    }}
                    getBranchData={getBranchData}
                    branchFieldName="branchCode"
                  />
                  {/* <Field id="clientCode" name="clientCode" placeholder="Search.." /> */}

                </FormUi.Field>
                <FormUi.Field width='8'>

                  <label htmlFor="branchCode">{fields.branch.title}</label>
                  <Field component={CustomerBranchDropdown}
                    name="branchCode"
                    branchData={props.branchOptions || branchData}
                    placeholder={fields.branch.placeholder}
                    value={props.selectedBranch || ''}
                    getBranchSelected={getBranchSelected}
                  />
                </FormUi.Field>
              </FormUi.Group>
              <br />
              <br />
              <br />
              <br />
              <center><button className='mt-4 btn btn-primary' type="submit">{buttons.applyFilter}</button></center>
            </Form>
          </Formik>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleReset} >{buttons.reset}</Button>
      </Modal.Actions>
    </Modal>

  )
}

export default CreditNoteFilterModal
